import { Injectable, Signal, computed, inject } from '@angular/core';

import { InsightsOrganizationInfoService } from '@mp/shared/app-insights/util';
import { ProfileFacade } from '@mpauth/shared/data-access';

/**
 * The implementation of InsightsOrganizationInfoService that provides the currently selected organization name.
 */
@Injectable()
export class AppInsightsOrganizationInfoService extends InsightsOrganizationInfoService {
  readonly organizationName: Signal<string | null> = computed(
    () => this.profileFacade.profile()?.activeOrganization?.name ?? null,
  );

  private readonly profileFacade: ProfileFacade = inject(ProfileFacade);
}
